module.exports = __webpack_public_path__ + "img/rye.be5030ca.webp";